import { Factory, trait, association } from 'miragejs';
import faker from 'faker';
import { addDays } from 'date-fns';

import { PAGE_TYPE } from '@api/pages/constants';

const created = faker.date.past();

export default {
  // TODO: refactor as common versioned Factory
  page: Factory.extend({
    title: (i) => `${i} ${faker.lorem.sentence()}`,
    typeId: () => faker.random.arrayElement([PAGE_TYPE.CONTENT.id, PAGE_TYPE.LANDING.id]),

    // TODO: refactor as common
    currentVersionId: () => faker.random.uuid(),
    publishedVersionId: () => faker.random.uuid(),

    // TODO: refactor as common
    seoDescription: () => faker.lorem.sentences(),
    slug: () => faker.lorem.slug(),

    // TODO: refactor as common
    created: () => created.toISOString(),
    createdBy: association(),
    modified: () => addDays(created, 1).toISOString(),
    modifiedBy: association(),
    published: () => addDays(created, 2).toISOString(),
    publishedBy: association(),

    contentModules: [],

    typeofContent: trait({
      typeId: PAGE_TYPE.CONTENT.id,
    }),

    typeofLanding: trait({
      typeId: PAGE_TYPE.LANDING.id,
    }),

    typeofCompetitionLanding: trait({
      typeId: PAGE_TYPE.COMPETITION_LANDING.id,
      competition: association(),
      event: association(),
    }),

    withParentPage: trait({
      // FIXME: doesn't work on belongsTo self-referential relationship. Consider to open an issue
      // parentPage: association('page'),
      // But this works
      afterCreate(page, server) {
        if (!page.parentPage) {
          page.update({
            parentPage: server.create('page'),
          });
        }
      },
    }),
  }),
};
